import * as React from 'react'
import type { SVGProps } from 'react'

function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 240 250" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="c">
        <path d="M211.72,191.9c-8.91,0-14.19-2.29-24.57-8.73-9.64-5.99-14.17-7.98-21.93-7.98s-12.28,1.99-21.93,7.98c-10.38,6.44-15.65,8.73-24.57,8.73s-14.19-2.29-24.56-8.73c-9.65-5.99-14.17-7.98-21.93-7.98s-12.28,1.99-21.93,7.98c-10.38,6.44-15.65,8.73-24.57,8.73s-14.19-2.29-24.57-8.73c-1.17-.73-1.53-2.27-.81-3.44.73-1.18,2.27-1.53,3.44-.81,9.64,5.99,14.17,7.98,21.93,7.98s12.29-1.99,21.93-7.98c10.38-6.44,15.65-8.73,24.57-8.73s14.18,2.29,24.57,8.73c9.64,5.99,14.17,7.98,21.93,7.98s12.29-1.99,21.93-7.98c10.38-6.44,15.65-8.73,24.57-8.73s14.19,2.29,24.57,8.73c9.64,5.99,14.17,7.98,21.93,7.98s12.29-1.99,21.93-7.98c1.17-.73,2.71-.37,3.44.81.73,1.17.37,2.71-.81,3.44-10.38,6.44-15.65,8.73-24.57,8.73Z" />
        <path d="M118.73,87.6c-13.65,0-24.76-11.11-24.76-24.76s11.11-24.76,24.76-24.76,24.76,11.11,24.76,24.76-11.11,24.76-24.76,24.76ZM118.73,43.08c-10.89,0-19.76,8.86-19.76,19.76s8.86,19.76,19.76,19.76,19.76-8.86,19.76-19.76-8.86-19.76-19.76-19.76Z" />
        <path d="M67.33,175.5h-.04c-1.38-.02-2.48-1.15-2.47-2.53l.57-41.81c-.4-8.4,2.44-16.51,8.01-22.82,6.11-6.93,14.91-10.9,24.14-10.9h42.36c9.24,0,18.04,3.97,24.14,10.9,5.57,6.31,8.41,14.41,8.01,22.82l.42,25.77c.02,1.38-1.08,2.52-2.46,2.54h-.04c-1.36,0-2.48-1.09-2.5-2.46l-.42-25.85c0-.06,0-.11,0-.17.36-7.12-2.04-13.99-6.76-19.34-5.16-5.85-12.59-9.21-20.39-9.21h-42.36c-7.8,0-15.23,3.36-20.39,9.21-4.72,5.35-7.12,12.22-6.76,19.34,0,.05,0,.11,0,.16l-.58,41.88c-.02,1.37-1.14,2.47-2.5,2.47Z" />
        <path d="M93.23,163.62s-.06,0-.09,0c-1.38-.05-2.46-1.21-2.41-2.59l.76-21.13c.05-1.38,1.21-2.45,2.59-2.41,1.38.05,2.46,1.21,2.41,2.59l-.76,21.13c-.05,1.35-1.16,2.41-2.5,2.41Z" />
        <path d="M144.24,163.62c-1.34,0-2.45-1.06-2.5-2.41l-.76-21.13c-.05-1.38,1.03-2.54,2.41-2.59,1.36-.05,2.54,1.03,2.59,2.41l.76,21.13c.05,1.38-1.03,2.54-2.41,2.59-.03,0-.06,0-.09,0Z" />
        <rect
          height="5"
          transform="translate(-12.4 42.23) rotate(-33.6)"
          width="143"
          x="-7.76"
          y="39.15"
        />
        <rect
          height="5"
          transform="translate(304.57 175.24) rotate(-146.4)"
          width="143"
          x="107.24"
          y="39.15"
        />
      </g>
    </svg>
  )
}

export default Icon
